export function Spinner({ label }: { label?: string }) {
  return (
    <span class="spinner-wrap">
      <span class="spinner" />
      {label && <span class="spinner-label">{label}</span>}
    </span>
  );
}
